import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

const usePersistedState = (key, defaultValue) => {
  const { projectId } = useParams();
  const namespacedKey = projectId ? `${projectId}:${key}` : key;

  const [state, setState] = useState(() => {
    const savedValue = localStorage.getItem(namespacedKey);
    if (savedValue === null) return defaultValue;

    try {
      return JSON.parse(savedValue);
    } catch (_error) {
      // If parsing fails, return the raw value. This is expected for normal string values
      return savedValue;
    }
  });

  useEffect(() => {
    // Only stringify if the value is not a primitive
    const valueToStore =
      typeof state === "object" ? JSON.stringify(state) : state;
    localStorage.setItem(namespacedKey, valueToStore);
  }, [namespacedKey, state]);

  return [state, setState];
};

export default usePersistedState;
